import {ReelAreaView} from "@nolimitcity/slot-game/bin/core/reel/reelarea/ReelAreaView";
import {FITHGameConfig} from "../../FITHGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {FITHParsedInitData} from "../../server/data/FITHParsedInitData";
import {FITHParsedGameData} from "../../server/data/FITHParsedGameData";
import {FITHGameMode} from "../../gameMode/FITHGameMode";
import {FITHGameModuleConfig} from "../../FITHGameModuleConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {FITHAvalancheReelController} from "../FITHAvalancheReelController";

export class FITHReelAreaView extends ReelAreaView {
    private _currentMode: string = "";
    private _resourcesLoaded: boolean = false;

    private readonly _bonusGameRow0: PIXI.Container;

    private readonly _bonusGameRow1: PIXI.Container;
    private readonly _bonusGameRow2: PIXI.Container;
    private readonly _bonusGameRow3: PIXI.Container;
    private readonly _bonusGameRow4: PIXI.Container;
    private readonly _bonusGameRow5: PIXI.Container;

    private _bonusGameRows: PIXI.Container[];

    private _bonusGameRow0Mask: PIXI.Graphics;

    private _bonusGameRow1Mask: PIXI.Graphics;
    private _bonusGameRow2Mask: PIXI.Graphics;
    private _bonusGameRow3Mask: PIXI.Graphics;
    private _bonusGameRow4Mask: PIXI.Graphics;
    private _bonusGameRow5Mask: PIXI.Graphics;

    private _openPositionsBonus: boolean[][] = [];
    private _bonusValues: number[][] = [];

    constructor() {
        super();

        this._bonusGameRow0 = new PIXI.Container();

        this._bonusGameRow1 = new PIXI.Container();
        this._bonusGameRow2 = new PIXI.Container();
        this._bonusGameRow3 = new PIXI.Container();
        this._bonusGameRow4 = new PIXI.Container();
        this._bonusGameRow5 = new PIXI.Container();

        this._bonusGameRow1.visible = false;
        this._bonusGameRow2.visible = false;
        this._bonusGameRow3.visible = false;
        this._bonusGameRow4.visible = false;
        this._bonusGameRow5.visible = false;

        this.addEventHandlers();
    }

    private static setReelsToBonusReels(): void {
        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM; i++) {
            let reel: (StateReelSymbol | null)[] = Reels.allSymbols(i);
            for (let j: number = 0; j < reel.length; j++) {
                reel[j]!.replaceWith("X", j);
            }
        }
    }

    public enterFS(): void {
        const reelsNumOriginal: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;

        this.updateMask(true);
        this.enableBonusGameMode();

        FITHReelAreaView.setReelsToBonusReels();

        FITHGameModuleConfig.background.enterFS();
        FITHGameModuleConfig.reelBackgroundView.enterFS();
        FITHGameModuleConfig.reelFrameView.enterFS();
        FITHGameModuleConfig.winWaysBoard.enterFS();
        for (let i: number = 0; i < FITHGameConfig.instance.REELS_NUM; i++) {
            (Reels.getReel(i) as FITHAvalancheReelController).enterFS();
        }
        for (let i: number = 0; i < reelsNumOriginal; i++) {
            const startSymId: number = 3;
            for (let j: number = startSymId; j < (FITHGameConfig.instance.SYMBOLS_NUM_IN_REEL[2] - 1); j++) {
                if (!this._openPositionsBonus[i][j]) {
                    FITHGameModuleConfig.bonusGameVSymbolOverlayView.toggleDOverlaySymbol(i, j, true);
                } else if (this._openPositionsBonus[i][j] && !this._bonusValues[i][j]) {
                    FITHGameModuleConfig.spinController.enableBonusReel((i * reelsNumOriginal) + j);
                }
            }
            // #151
            FITHGameModuleConfig.bonusGameVSymbolOverlayView.toggleBottomRowWagon(i, true);
            Reels.getSymbol(((i * reelsNumOriginal) + (reelsNumOriginal - 1)), 0)?.setVisibility(false);
        }
    }

    public exitFS(): void {
        this.updateMask(false);
        this.disableBonusGameMode();
    }

    public enableBonusGameMode(): void {
        const originalReels: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;
        // Re-arrange all reels to get a different spin order in Bonus game
        for (let i: number = 0; i < originalReels; i++) {
            for (let j: number = 0; j < originalReels; j++) {
                this._bonusGameRows[j].addChild(this._reelViews[(i * originalReels) + j]);
            }
        }

        this._bonusGameRow1.visible = true;
        this._bonusGameRow2.visible = true;
        this._bonusGameRow3.visible = true;
        this._bonusGameRow4.visible = true;
        this._bonusGameRow5.visible = true;
        this._bonusGameRow0.addChild(this._bonusGameRow0Mask);
        this._bonusGameRow0.mask = this._bonusGameRow0Mask;

        this._currentMode = FITHGameMode.BONUS;
        this._reelViews.forEach((reelView: PIXI.Container, reelId: number) => {
            this.updateReelViewPosition(reelView, reelId);
        });
    }

    public disableBonusGameMode(): void {
        const originalReels: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL;

        this._bonusGameRow1.visible = false;
        this._bonusGameRow2.visible = false;
        this._bonusGameRow3.visible = false;
        this._bonusGameRow4.visible = false;
        this._bonusGameRow5.visible = false;
        this._bonusGameRow0.removeChild(this._bonusGameRow0Mask);
        // @ts-ignore
        this._bonusGameRow0.mask = null;

        for (let i: number = 0; i < originalReels; i++) {
            for (let j: number = 0; j < originalReels; j++) {
                this._bonusGameRows[i].addChild(this._reelViews[(i * originalReels) + j]);
            }
        }
        this._currentMode = FITHGameMode.NORMAL;
        this._reelViews.forEach((reelView: PIXI.Container, reelId: number) => {
            this.updateReelViewPosition(reelView, reelId);
        });
    }

    protected initAnimations() {
        super.initAnimations && super.initAnimations();

        this._bonusGameRows = [];

        this.addChild(this._bonusGameRow0);
        this._bonusGameRows.push(this._bonusGameRow0);

        this.addChild(this._bonusGameRow1);
        this._bonusGameRows.push(this._bonusGameRow1);
        this.addChild(this._bonusGameRow2);
        this._bonusGameRows.push(this._bonusGameRow2);
        this.addChild(this._bonusGameRow3);
        this._bonusGameRows.push(this._bonusGameRow3);
        this.addChild(this._bonusGameRow4);
        this._bonusGameRows.push(this._bonusGameRow4);
        this.addChild(this._bonusGameRow5);
        this._bonusGameRows.push(this._bonusGameRow5);

        const originalReels: number = FITHGameConfig.instance.REELS_NUM_ORIGINAL,
            yPositions: number[] = [0, 90, 180, 264, 350, 438];

        for (let i: number = 0; i < originalReels; i++) {
            for (let j: number = 0; j < originalReels; j++) {
                this._bonusGameRows[i].addChild(this._reelViews[(i * originalReels) + j]);
            }
            this._bonusGameRows[i].position.y = yPositions[i];
        }

        this._resourcesLoaded = true;
        this.gameReady();
    }

    protected UpdateReelAreaMask(): void {
        super.UpdateReelAreaMask();

        if (!this._bonusGameRow0Mask) {
            this._bonusGameRow0Mask = new PIXI.Graphics();
            this._bonusGameRow0Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow0Mask.drawRect(-FITHGameConfig.instance.REEL_AREA_POS_X, 0, FITHGameConfig.instance.REEL_AREA_WIDTH, (FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));
            this._bonusGameRow0Mask.endFill();
        }

        if (!this._bonusGameRow1Mask) {
            this._bonusGameRow1Mask = new PIXI.Graphics();
            this._bonusGameRow1Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow1Mask.drawRect(-FITHGameConfig.instance.REEL_AREA_POS_X, 0, FITHGameConfig.instance.REEL_AREA_WIDTH, (FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));
            this._bonusGameRow1Mask.endFill();
            this._bonusGameRow1.addChild(this._bonusGameRow1Mask);
            this._bonusGameRow1.mask = this._bonusGameRow1Mask;
        }

        if (!this._bonusGameRow2Mask) {
            this._bonusGameRow2Mask = new PIXI.Graphics();
            this._bonusGameRow2Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow2Mask.drawRect(-FITHGameConfig.instance.REEL_AREA_POS_X, 0, FITHGameConfig.instance.REEL_AREA_WIDTH, (FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));
            this._bonusGameRow2Mask.endFill();
            this._bonusGameRow2.addChild(this._bonusGameRow2Mask);
            this._bonusGameRow2.mask = this._bonusGameRow2Mask;
        }

        if (!this._bonusGameRow3Mask) {
            this._bonusGameRow3Mask = new PIXI.Graphics();
            this._bonusGameRow3Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow3Mask.drawRect(-FITHGameConfig.instance.REEL_AREA_POS_X, 0, FITHGameConfig.instance.REEL_AREA_WIDTH, (FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));
            this._bonusGameRow3Mask.endFill();
            this._bonusGameRow3.addChild(this._bonusGameRow3Mask);
            this._bonusGameRow3.mask = this._bonusGameRow3Mask;
        }

        if (!this._bonusGameRow4Mask) {
            this._bonusGameRow4Mask = new PIXI.Graphics();
            this._bonusGameRow4Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow4Mask.drawRect(-FITHGameConfig.instance.REEL_AREA_POS_X, 0, FITHGameConfig.instance.REEL_AREA_WIDTH, (FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));
            this._bonusGameRow4Mask.endFill();
            this._bonusGameRow4.addChild(this._bonusGameRow4Mask);
            this._bonusGameRow4.mask = this._bonusGameRow4Mask;
        }

        if (!this._bonusGameRow5Mask) {
            this._bonusGameRow5Mask = new PIXI.Graphics();
            this._bonusGameRow5Mask.beginFill(0xFFFFFF, 1);
            this._bonusGameRow5Mask.drawRect(-FITHGameConfig.instance.REEL_AREA_POS_X, 0, FITHGameConfig.instance.REEL_AREA_WIDTH, (FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME));
            this._bonusGameRow5Mask.endFill();
            this._bonusGameRow5.addChild(this._bonusGameRow5Mask);
            this._bonusGameRow5.mask = this._bonusGameRow5Mask;
        }
    }

    protected updateReelViewPosition(reelView: PIXI.Container, reelId: number): void {
        let position: [number, number] = FITHGameConfig.instance.REEL_DISPLAY_POSITIONS[reelId];
        if (this._currentMode === FITHGameMode.BONUS) {
            position = FITHGameConfig.instance.REEL_DISPLAY_POSITIONS_BONUS_GAME[reelId];
        }
        reelView.x = position[0];
        reelView.y = position[1];
    }

    private addEventHandlers(): void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    private onInitDataParsed(data: FITHParsedInitData): void {
        this._currentMode = data.mode;
        FITHGameModuleConfig.reels.mode = data.mode;
        this._openPositionsBonus = data.openPositionsBonus;
        this._bonusValues = data.bonusValues;

        this.gameReady();

        EventHandler.removeEventListener(this, ServerEvent.INIT_DATA_PARSED);
    }

    private onGameDataParsed(data: FITHParsedGameData): void {
        this._currentMode = data.mode;
        FITHGameModuleConfig.reels.mode = data.mode;
        this._openPositionsBonus = data.openPositionsBonus;
        this._bonusValues = data.bonusValuesAfterSpin;
    }

    private updateMask(isEnteringFS: boolean): void {
        const reelAreaWidth: number = FITHGameConfig.instance.REEL_AREA_WIDTH;

        let y: number = FITHGameConfig.instance.REEL_AREA_POS_Y,
            reelAreaHeight: number = FITHGameConfig.instance.REEL_AREA_HEIGHT,
            yOffset: number = 20,
            heightOffset: number = 20;

        if (isEnteringFS) {
            reelAreaHeight = FITHGameConfig.instance.REEL_AREA_HEIGHT_BONUS_GAME;
            y = FITHGameConfig.instance.REEL_AREA_POS_Y_BONUS_GAME;
            yOffset = -(FITHGameConfig.instance.SYMBOL_HEIGHT_BONUS_GAME);
            heightOffset = 0;
        }

        FITHGameConfig.instance.REEL_AREA_MASK_RECT = new PIXI.Rectangle(0, y - yOffset, reelAreaWidth, reelAreaHeight + heightOffset);
        this.UpdateReelAreaMask();
    }

    private gameReady(): void {
        if (this._resourcesLoaded && this._currentMode === FITHGameMode.BONUS) {
            this.enterFS();
            this._resourcesLoaded = false;
        }
    }
}